import { STRING_ANY_HASH } from '../constants';

/**
 * Pass it a root object, a path, and a value. It will go recursively
 * through the object and set the correct key to the value. It returns
 * the entire object MODIFIED. If you don't want the original modified,
 * pass it the clone paramter.
 * 
 * @example
      const clone = setRecursive({
        root: original,
        path: 'a.b.c',
        value: 'new value',
        clone: true,
      });
 * 
 * @param param0 
 * @returns 
 */
export const setPropertyValueByPath = ({
  path,
  root,
  obj,
  value,
  clone = false,
}: {
  root: any;
  obj?: STRING_ANY_HASH;
  path: string;
  value: any;
  clone?: boolean;
}): any => {
  if (clone) root = JSON.parse(JSON.stringify(root));
  if (!obj) obj = root ? root : {};
  const pcs: string[] = path.split('.');
  const car = pcs.shift();
  const cdr = pcs.join('.');
  if (obj && car) {
    if (!cdr) {
      obj[car] = value;
      return root;
    }
    obj[car] = obj[car] || {}; // Create it if it does not exist.
    return setPropertyValueByPath({ root, obj: obj[car], path: cdr, value });
  }
  return obj;
};
